import React from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import CashFormatter from './cashFormatter';
import { Button, Col, Input, Row } from 'react-bootstrap';
import GenericSelection from './GenericSelection';
import { vakDimensionsOptions, vakLogisticCarrierOptions } from '../../utils/constant';
import axios from 'axios';
import { ROOT_URL } from '../../actions/root_url';
import cloneDeep from 'lodash/cloneDeep';
import { concat } from 'lodash';
import { roundToDecimals } from './NumberUtil';

const AddressAttributeFormatter = React.createClass({
  render() {
    const {dependentValues} = this.props;
    let addressAttribute = [];
    if(dependentValues.Address_Attribute == 'MIXED') {
      addressAttribute.push({label:'home', classNmae: 'fa-green'});
      addressAttribute.push({label:'building', classNmae: 'fa-blue'});
    } else if(dependentValues.Address_Attribute == 'RESIDENTIAL') {
      addressAttribute.push({label:'home', classNmae: 'fa-green'});
    } else if(dependentValues.Address_Attribute == 'BUSINESS') {
      addressAttribute.push({label:'building', classNmae: 'fa-blue'});
    } else {
      addressAttribute.push({label:''});
    }
    return <div>
      <Row>
        <div className={'col-xs-3'}>
          {addressAttribute.map(item => {
            return item.label ? <em className={`fa fa-${item.label} ${item.classNmae}`}></em> : ''
          })}
        </div>
      </Row>
    </div>
  }
});
class AutoPrintModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      salesOrders: {
        rows: [],
        selectedRows: [],
      },
      carrier: null,
      dimensions: null,
      isCustomSize: false,
      isLoading: false,
    }
  }

  componentDidMount() {
    if (this.props.salesOrders && this.props.salesOrders.selectedRows.length > 0) {
      this.refreshOrders(this.props.salesOrders.selectedRows);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // if (nextProps.salesOrders
    //   && nextProps.salesOrders.selectedRows.length > 0
    //   && nextProps.salesOrders.selectedRows !== this.props.salesOrders.selectedRows) {
    //   this.refreshOrders(nextProps.salesOrders.selectedRows);
    // }
  }
  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevState.carrier !== this.state.carrier) {
      const carrier = vakLogisticCarrierOptions.find(option => option.value === this.state.carrier);
      if (carrier.size !== undefined) {
        this.setState({
          dimensions: carrier.size,
          isCustomSize: true,
        })
      } else {
        this.setState({
          dimensions: null,
          isCustomSize: false,
        })
      }
    }
    if (prevState.dimensions !== this.state.dimensions) {
      if (this.state.dimensions === 'other') {
        this.setState({
          dimensions: null,
          isCustomSize: true,
        })
      }
      this.setState({
        salesOrders: {
          ...this.state.salesOrders,
          rows: [
            ...this.state.salesOrders.rows.map(row => ({...row, dimensions: this.state.dimensions}))]
        },
      }, () => {
        this.setState({
          salesOrders: {
            ...this.state.salesOrders,
            selectedRows: cloneDeep(this.state.salesOrders.rows.filter(row => row.isSelected)),
          }
        })
      })
    }
  }

  handleOnSavePrint = () => {
    this.setState({
      isLoading: true,
    });
    axios.post(`${ROOT_URL}v1/sale/shipping/mu_batch_ship/`, {
      information: this.state.salesOrders.selectedRows.map(row => ({
        order_id: row.SalesOrder_id,
        carrier: this.state.carrier,
        weight: row.FinalNetWeight,
        dimensions: this.state.dimensions,
        is_custom_size: this.state.isCustomSize,
      })),
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then(response => {
      this.setState({
        isLoading: false,
      });
      this.props.afterSave(response);
    }).catch(() => {
      this.setState({
        isLoading: false,
      });
    })
  }

  handleOnSave = () => {
    this.setState({
      isLoading: true,
    });
    let cpRows = [...this.state.salesOrders.selectedRows];
    cpRows.sort((a, b) => {
      return new Date(a.OrderDate) - new Date(b.OrderDate);
    })
    let data = cpRows.map(row => ({
      order_id: row.SalesOrder_id,
      carrier: this.state.carrier,
      weight: row.FinalNetWeight,
      dimensions: this.state.dimensions,
      is_custom_size: this.state.isCustomSize,
    }))
    axios.post(`${ROOT_URL}v1/sale/shipping/mu_batch_ship/`, {
      information: data,
    }, {
      params: {not_show_labels: true},
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((response) => {
      this.setState({
        isLoading: false,
      });
      this.props.afterSave(response);
    }).catch((err) => {
      alert(JSON.stringify((err || {data:'Failed'}).data));
      this.setState({
        isLoading: false,
      });
    });
  }

  refreshOrders = newOrders => {
    this.setState({
      salesOrders: {
        rows: [...newOrders],
        selectedRows: [...newOrders],
      }
    })
  }
  handleGetLogisticPrice = () => {
    this.setState({
      isLoading: true,
    });
    axios.post(`${ROOT_URL}v1/sale/shipping/service_price/`, {
      information: this.state.salesOrders.selectedRows.map(row => ({
        order_id: row.SalesOrder_id,
        carrier: this.state.carrier,
        weight: row.FinalNetWeight,
        dimensions: this.state.dimensions,
        is_custom_size: this.state.isCustomSize,
      })),
    },{
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then(response => {
      const rows = this.state.salesOrders.rows;
      Object.entries(response.data || {}).map(([orderId, response]) => {
        const data = response[this.state.carrier === 'usps_priority_mail_env' ? 1 : 0];
        const idx = rows.findIndex(row => row.SalesOrder_id === parseInt(orderId));
        if (idx !== -1) {
          rows[idx].price = (data.shipmentCost || 0) + (data.otherCost || 0);
        }
      })
      this.setState({
        salesOrders: {
          ...this.state.salesOrders,
          rows: cloneDeep(rows),
        },
        isLoading: false,
      });
    }).catch(() => {
      this.setState({
        isLoading: false,
      });
    })
  }
  renderOrderTable = () => {
    const tableHeight = 360;
    const getRows = () => Data.Selectors.getRows(this.state.salesOrders);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrders, {
        sortColumn,
        sortDirection,
      });
      this.setState({ salesOrders: state });
    };

    // Handle the row select function
    const onRowClick = (idx) => {
      const newRows = getRows();
      newRows[idx].isSelected = true;
      const selectedRows = newRows.filter(row => row.isSelected === true);
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    }
    const onRowsSelected = rows => {
      const newRows = getRows();
      rows.forEach(row => {
        newRows[row.rowIdx].isSelected = true;
      });
      const selectedRows = newRows.filter(row => row.isSelected === true);
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    };
    const onRowsDeselected = rows => {
      const newRows = getRows();
      rows.forEach(row => {
        newRows[row.rowIdx].isSelected = false;
      });
      const selectedRows = newRows.filter(row => row.isSelected === true);
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    }
    const handleRowUpdated = e => {
      const newRows = getRows();
      newRows[e.rowIdx] = {...newRows[e.rowIdx], ...e.updated};
      const selectedRows = newRows.filter(row => row.isSelected === true);
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    }

    const columns = [{
      key: "SONum",
      name: <Translate value="so_no" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 140,
      getRowMetaData: row => row,
    }, {
      key: "Platform_Num",
      name: <Translate value="cpo_no" />,
      resizable: true,
      sortable: true,
      width: 95,
      filterable: true,
    }, {
      key: "FinalPrice",
      name: <Translate value="final_dollarsign" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
      formatter: CashFormatter,
    },{
      key: "Address_Attribute",
      name: <Translate value="address_attribute" />,
      resizable: true,
      width: 80,
      getRowMetaData: row => row,
      formatter: AddressAttributeFormatter,
    }, {
      key: "FinalNetWeight",
      name: <Translate value="final_weight_lbs"/>,
      resizable: true,
      sortable: true,
      editable: true,
      width: 100,
      filterable: true,
      getRowMetaData: row => row,
      formatter: ({dependentValues, value}) => {
        const dimension = concat(vakDimensionsOptions, vakLogisticCarrierOptions).find(option => option.size === this.state.dimensions);
        return <span>{roundToDecimals(parseFloat(value) + (dimension && dimension.weight || 0))}</span>
      }
    }, {
      key: "dimensions",
      name: <Translate value="dimensions"/>,
      resizable: true,
      width: 100,
      filterable: true,
    }, {
      key: "price",
      name: <Translate value="price" />,
      resizable: true,
      width: 100,
      filterable: true,
    }, {
      key: "OrderDate",
      name: <Translate value="ordered" />,
      resizable: true,
      sortable: true,
      width: 95,
      filterable: true,
    }]
    return <ReactDataGrid
      enableCellSelect={true}
      rowKey="SalesOrderLine_id"
      onGridSort={handleGridSort}
      columns={columns}
      rowGetter={rowGetter}
      rowsCount={getSize()}
      rowHeight={25}
      headerRowHeight={45}
      minHeight={tableHeight}
      onRowUpdated={handleRowUpdated}
      selectedRows={this.state.salesOrders.selectedRows}
      enableRowSelect="single"
      onRowClick={onRowClick}
      rowSelection={{
        showCheckbox: true,
        enableShiftSelect: true,
        onRowsSelected,
        onRowsDeselected,
        selectBy: {
          isSelectedKey: "isSelected",
        },
      }}
    />
  }
  render() {
    const everyOrderHasWeight = this.state.salesOrders.selectedRows.every(row => !!row.FinalNetWeight);
    return <div style={{width: 770}}>
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={5}><Translate value={"carrier"}/></Col>
            <Col xs={5}><Translate value={"dimensions"}/></Col>
            <Col xs={2}><Translate value={"action"}/></Col>
          </Row>
          <Row>
            <Col xs={5}>
              <GenericSelection
                className={'carrier-dropdown'}
                options={vakLogisticCarrierOptions}
                value={this.state.carrier}
                setSelected={({ value }) => this.setState({carrier: value})}
              />
            </Col>
            <Col xs={5}>
              {
                this.state.isCustomSize
                ? <Input
                    standalone
                    type="text"
                    className="form-control"
                    value={this.state.dimensions}
                    onChange={({target: {value}}) => {
                      this.setState({dimensions: value})
                    }}/>
                : <GenericSelection
                    className={'carrier-dropdown'}
                    options={vakDimensionsOptions}
                    value={this.state.dimensions}
                    setSelected={({ value }) => this.setState({dimensions: value})}
                  />
              }
            </Col>
            <Col xs={2}>
              <Button
                bsStyle={'success'}
                onClick={() => this.handleGetLogisticPrice()}
                disabled={!this.state.carrier || !this.state.dimensions || !everyOrderHasWeight || this.state.isLoading}
              ><Translate value={"show_price"}/>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{maxWidth: 770, marginTop: '10px'}}>
        <Col xs={12}>
          {this.renderOrderTable()}
        </Col>
      </Row>
      <Row className="centerStyle" style={{ marginTop: '10px' }}>
        <Button
          bsStyle="primary"
          style={{ marginRight: '5px' }}
          disabled={!this.state.carrier || !this.state.dimensions || !everyOrderHasWeight || this.state.isLoading}
          onClick={(e) => { this.handleOnSave(e); }}
        >
          <Translate value="save" />
        </Button>
        {/* <Button */}
        {/*   bsStyle="success" */}
        {/*   disabled={!this.state.carrier || !this.state.dimensions || !everyOrderHasWeight || this.state.isLoading} */}
        {/*   onClick={(e) => { this.handleOnSavePrint(e); }} */}
        {/* > */}
        {/*   <Translate value="save_and_print" /> */}
        {/* </Button> */}
      </Row>
    </div>;
  }
}
export default AutoPrintModal



// WEBPACK FOOTER //
// ./master/jsx/components/Common/autoPrintModal.jsx